import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';

@Component({
  selector: 'app-anti-martingala',
  standalone: true,
  templateUrl: './anti-martingala.component.html',
  styleUrls: ['./anti-martingala.component.scss'],
  imports: [ReactiveFormsModule, CommonModule, MdbSelectModule]
})
export class AntiMartingalaComponent implements OnInit {

  prezzo = 10000
  lottiPrimaOperazione:Array<any> = []
  lottiIniziali = 1
  verso = "buy"
  numeroOperazioni = 20
  step = 5
  stopLoss = 50
  trail = this.stopLoss
  takeProfit = 100
  livelloJumpSL!:number
  listaOperazioni:Array<any> = []
  listaSSL:Array<any> = []
  listaProfit:Array<any> = []
  profitEffettivo:Array<any> = []
  chartLabels:Array<any> = []
  chartData: any[] = []
  chartOptions: any = {
    responsive: true
  };
  operazione!: FormGroup;
  constructor() {
    for (let i = 1; i <= 50; i++) {
      this.lottiPrimaOperazione.push(
        { value: i, label: i }
      )
    }
  }

  ngOnInit(): void {
    this.operazione = new FormGroup({
      stepOp: new FormControl(this.step, Validators.required),
      numOp: new FormControl(this.numeroOperazioni, Validators.required),
      stopL: new FormControl(this.stopLoss, Validators.required),
      profit: new FormControl(this.takeProfit, Validators.required),
      lotti: new FormControl(this.lottiIniziali, Validators.required),
      checkLVL: new FormControl(false),
      lvlStopLoss: new FormControl(this.livelloJumpSL, Validators.required),
      trailForm: new FormControl(this.trail, Validators.required),
    });
    this.lvlStopLoss.disable()
    this.analizza()
  }

  get stepOp() { return this.operazione.get('stepOp') as FormControl }
  get numOp() { return this.operazione.get('numOp') as FormControl }
  get stopL() { return this.operazione.get('stopL') as FormControl }
  get profit() { return this.operazione.get('profit') as FormControl }
  get lotti() { return this.operazione.get('lotti') as FormControl }
  get lvlStopLoss() { return this.operazione.get('lvlStopLoss') as FormControl }
  get checkLVL() { return this.operazione.get('checkLVL') as FormControl }
  get trailForm() { return this.operazione.get('trailForm') as FormControl }

  check() {
    if (this.lvlStopLoss.disabled) {
      this.lvlStopLoss.enable()
    } else {
      this.livelloJumpSL = 0
      this.lvlStopLoss.disable()
    }
  }

  analizza() {
    if (this.listaSSL.length) {
      this.listaOperazioni = []
      this.listaSSL = []
      this.chartLabels = []
      this.chartData = []
      this.listaProfit = []
      this.profitEffettivo = []
    }
    if (!this.lvlStopLoss.disabled) {
      this.livelloJumpSL = parseInt(this.lvlStopLoss.value)
    }
    this.takeProfit = parseInt(this.profit.value)
    this.numeroOperazioni = parseInt(this.numOp.value)
    this.stopLoss = parseInt(this.stopL.value)
    this.step = parseInt(this.stepOp.value)
    this.lottiIniziali = parseInt(this.lotti.value)
    this.trail = parseInt(this.trailForm.value)

    for(let i = 0,p = this.prezzo;i<this.numeroOperazioni;i++,p+=this.step){
      let op = new Operazione (p,this.stopLoss,this.takeProfit,this.trail)
      if(this.lottiIniziali>1){
        op.lotti=this.lottiIniziali
        this.lottiIniziali=1
      }else{
        op.lotti=this.lottiIniziali
      }
      this.listaOperazioni.push(op)
    }
    this.calcola()
  }

  calcola() {

    let n = this.numeroOperazioni + this.takeProfit / this.step + 5

    for(let i=0,price=this.prezzo ; i<n ; i++,price+=this.step){
      if(this.livelloJumpSL&&this.listaProfit[i-1]>=this.livelloJumpSL){
        this.livelloJumpSL=0
        let prezzoIniziale = this.listaOperazioni[0].prezzo

        this.listaOperazioni.forEach(
          (op:Operazione)=>{
            if(op.prezzo-op.trail<prezzoIniziale){
              op.stopLoss=prezzoIniziale
            }
          })
      }
        this.listaSSL.push(this.calcolaSL(price))
        this.listaProfit.push(this.calcolaProfit(price))
        this.profitEffettivo.push(this.calcolaProfitEffettivo(price))
        this.chartLabels.push(i * this.step)
    }
    this.chartData
     = [
      { data: this.listaSSL, label: "Somma Stop Loss",
      backgroundColor: 'rgba(105, 0, 132, .2)',
      borderColor: 'rgba(200, 99, 132, .7)',
      borderWidth: 2, },
      { data: this.listaProfit, label: 'Profit attuale',
      backgroungColor: 'rgba(54, 162, 235, 0.2)',
      borderColor: 'rgba(54, 162, 235, 1)',
      borderWidth: 2 },
      { data: this.profitEffettivo, label: 'Profit Effettivo',
      backgroungColor: 'rgba(255, 206, 86, 0.2)',
      borderColor: 'rgba(255, 206, 86, 1)',
      borderWidth: 2 },  
    ]
  }

  calcolaSL(p:number):number{
    let sl:number 
    sl = 0
    this.listaOperazioni.forEach(
      (op:Operazione)=>{
        if(op.stopLoss<=p-op.trail&&op.aperta){
          op.stopLoss=p-op.trail
        }
        if(op.aperta){
          sl+=(op.stopLoss-op.prezzo)*op.lotti
        }
        if(p>=op.profit){
          if(op.aperta){
            op.aperta=false
            sl+=(p-op.stopLoss)*op.lotti
          }else{
          sl+=(op.profit-op.prezzo)*op.lotti
          }
        }
        
        if(p>=op.prezzo&&!op.aperta&&p<op.profit){
          op.aperta=true
          sl+=(op.stopLoss-op.prezzo)*op.lotti
        }
      
      })
        return sl
  }
  calcolaProfit(p:number):number{
    let ep = 0
    this.listaOperazioni.forEach(
      (op:Operazione)=>{
          if(op.aperta){
            ep+=(p-op.prezzo)*op.lotti
          }else{
            if(p>=op.profit){
              ep+=(op.profit-op.prezzo)*op.lotti
            }
          }
      })
        return ep
  }

  calcolaProfitEffettivo(p:number):number{
    let ep = 0
    this.listaOperazioni.forEach(
      (op:Operazione)=>{
        if(p>=op.profit){
          if(op.aperta){
            ep+=(op.profit-op.prezzo)*op.lotti
          }else{

            ep+=(op.profit-op.prezzo)*op.lotti
          }
        }
      })
        return ep
  }
}
class Operazione {
  lotti!:number;
  prezzo:number;
  stopLoss:number;
  profit:number;
  trail:number;
  aperta:boolean=false;
  constructor(p:number,sl:number,pr:number,tr:number){
    this.prezzo=p
    this.stopLoss=p-sl
    this.profit=p+pr
    this.trail=tr
  }
}

/* class trade {
  levelOpen
  levelSL
  levelProfit
} */